import {Injectable} from '@angular/core';
import {AnimalSheltersRepository} from 'src/app/shared/states/animal-shelter.repository';
import {AnimalRepository} from 'src/app/modules/animals/states/animal.repository';
import {take} from 'rxjs';
import {AuthService} from './auth.service';
import {CompetentAuthoritiesRepository} from '../states/competent-authorities.repository';
import {environment} from 'src/environment/environment';
import {TokenService} from './token.service';
import {DashboardLoadingService} from './dashboard-loading.service';

@Injectable({
  providedIn: 'root'
})
export class AppDataLoadService {

  constructor(
    private readonly _authService: AuthService,
    private readonly _animalRepository: AnimalRepository,
    private readonly _animalShelterRepository: AnimalSheltersRepository,
    private readonly _competentAuthoritiesRepository: CompetentAuthoritiesRepository,
    private readonly _tokenService: TokenService,
    private readonly _dashboardLoadingService: DashboardLoadingService
  ) {
  }

  async loadAppData() {
    const user = await this._authService.currentUser$.pipe(take(1)).toPromise();
    this._animalShelterRepository.loadAnimalShelters();
    this._competentAuthoritiesRepository.loadCompetentAuthorities();
    if (user && user.defaultAnimalShelter !== null) {
      this._animalRepository.getByShelter(user.defaultAnimalShelter.id).subscribe({
        complete: () => this._dashboardLoadingService.setLoading(false),
        error: () => this._dashboardLoadingService.setLoading(false)
      });
    } else {
      this._animalRepository.getAnimals$().subscribe({
        complete: () => this._dashboardLoadingService.setLoading(false),
        error: () => this._dashboardLoadingService.setLoading(false)
      });
    }
  }
}
